import styled from '@emotion/styled';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import { system } from "@/theme";
import Icon from "@imminently/decisively-ui/Icon";

/***
  @deprecated Use Chip instead
 ***/
export const Label = styled.span`
  // use fontsize, lineheight, padding to make total height of 1.5rem
  /* height: 1.5rem; */
  border-radius: 0.5rem;
  font-size: 0.75em;
  text-decoration: none;
  font-weight: 700;
  text-align: center;
  color: var(--primary-foreground);
  background-color: ${p => p.theme.mixins.system[p.color] ?? p.color};
  padding: 0.25rem 0.365rem;
  white-space: nowrap;
  cursor: default;
`;

export const FlexLabel = styled(Label)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`;

export const ExperimentalLabel = () => (
  <Tooltip title="This feature is experimental and may not work as expected">
    <FlexLabel color={system.trafficAmber10} style={{ color: system.trafficAmber, border: `1px solid ${system.trafficAmber}` }}>
      <span>Experimental</span>
    </FlexLabel>
  </Tooltip>
);

export const Tag = props => {
  return <Chip deleteIcon={<Icon name="clear" />} {...props} />;
};

export const TextLabel = styled(Typography)`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 0.5rem;
  width: 6rem;
  flex-shrink: 0;

  svg {
    width: 1rem;
    height: 1rem;
  }
`;

export const DocumentLink = styled(Typography)`
  padding: 0.5rem 0;
  cursor: pointer;
  text-decoration: underline;

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #e5e5e5;
  }
`;
